import { useMutation, useQueryClient } from '@tanstack/react-query'

import { setShipUserPreference } from './userProfile.service'

export const useSetShipUserPreference = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['setShipUserPreference'],
    mutationFn: setShipUserPreference,
    onSuccess: (data) => {
      queryClient.setQueryData(['shipUserPreference'], {
        owner: [data],
      })
    },
  })
}
